import { Grid, makeStyles, Button } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ValidatorForm } from "react-material-ui-form-validator";
import { red } from "@material-ui/core/colors";
import CancelIcon from "@material-ui/icons/Cancel";
import { STEPPER_RECLAMOS_FORM } from "../../../../../utils/constants";
import { setActiveStepReclamos } from "../../../../../actions/reclamos/reclamosActions";
import { ReclamosStepper } from "../../ModalIngresoReclamo/Stepper/ReclamosStepper";
import { ReclamoCabeceraExternos } from "./ReclamoCabeceraExternos";
import { ReclamosDatosFormExtenos } from "./ReclamosDatosFormExtenos";
import { NuevoReclamoExterno } from "../../../../../actions/reclamos/reclamosExternosActions";
import { DocumentacionIngresoExterno } from "./DocumentacionIngresoExterno";
import { ImpresionReclamoExterno } from "./ImpresionReclamoExterno";

const useStyles = makeStyles((theme) => ({
    button: {
      margin: 2,
      textAlign: "right",
    },
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    title: {
      fontSize: 12,
    },
    iconoTrash: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      color: "#fff",
      backgroundColor: red[500],
      marginLeft: "auto",
      marginRight: "auto",
    },
    contenedorTrash: {
      height: 170,
      textAlign: "center",
      marginTop: "auto",
      marginBottom: "auto",
    },
    tarjetaReadOnly: {
      pointerEvents: "none",
      opacity: 0.4,
    },
  }));



export const StepperIngresoReclamoExternos = (props) => {

    const { activeStep } = useSelector((state) => state.reclamos);
    const { formValues, dataExternos } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
  
    //let stepperMenu = STEPPER_RECLAMOS_FORM
  
    const onSubmit = () => {
      dispatch(NuevoReclamoExterno(formValues));
      dispatch(setActiveStepReclamos(STEPPER_RECLAMOS_FORM.DOCUMENTACION));
    };


  return (
    <>
    <Grid item xs={12}>
      <ReclamosStepper activeStep={activeStep} />
    </Grid>
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container spacing={1}>
        {activeStep === STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO && (
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <ReclamoCabeceraExternos
                formValues={formValues}
                classes={classes}
                {...props}
              />
              <Grid
                item
                xs={12}
                style={{ textAlign: "right", marginTop: "1em" }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  startIcon={<CancelIcon />}
                  onClick={props.handleCancel}
                  className={classes.button}
                >
                  CANCELAR
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={!(formValues.categoriaReclamo && formValues.tipoReclamo && formValues.tipoOrigen && formValues.destino)}
                  onClick={() => {
                    dispatch(
                      setActiveStepReclamos(
                        STEPPER_RECLAMOS_FORM.DATOS_RECLAMO
                      )
                    );
                  }}
                  className={classes.button}
                >
                  CONTINUAR
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
        {activeStep === STEPPER_RECLAMOS_FORM.DATOS_RECLAMO && (
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <ReclamosDatosFormExtenos
                  formValues={formValues}
                  classes={classes}
                  dataExternos={dataExternos}
                  handleInputChange={props.handleInputChange}
                  {...props}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ textAlign: "right", marginTop: "1em" }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => {
                    dispatch(
                      setActiveStepReclamos(
                        STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO
                      )
                    );
                  }}
                  className={classes.button}
                >
                  ANTERIOR
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={!(formValues.descripcion && formValues.email && formValues.celular)}
                  className={classes.button}
                  type="submit"
                >
                  SIGUIENTE / CONTINUAR
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
        {activeStep === STEPPER_RECLAMOS_FORM.DOCUMENTACION && (
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <DocumentacionIngresoExterno />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ textAlign: "right", marginTop: "1em" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    dispatch(
                      setActiveStepReclamos(STEPPER_RECLAMOS_FORM.IMPRESION)
                    );
                  }}
                  className={classes.button}
                >
                  CONTINUAR
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
        {activeStep === STEPPER_RECLAMOS_FORM.IMPRESION && (
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <ImpresionReclamoExterno titulo />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ textAlign: "right", marginTop: "1em" }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => {
                    dispatch(
                      setActiveStepReclamos(
                        STEPPER_RECLAMOS_FORM.DOCUMENTACION
                      )
                    );
                  }}
                  className={classes.button}
                >
                  ANTERIOR
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={props.handleCancel}
                  className={classes.button}
                >
                  GUARDAR
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </ValidatorForm>
  </>
  )
}
